import { fabric } from "fabric";

const DEFAULTS = {
  "glass-card": {
    cardBg: "#1e3a5f",
    cardBgEnd: "#2563eb",
    textColor: "#ffffff",
    accentColor: "#7dd3fc",
    metaColor: "#cbd5e1",
  },
  compact: {
    cardBg: "#0f766e",
    cardBgEnd: "#14b8a6",
    textColor: "#ffffff",
    accentColor: "#99f6e4",
    metaColor: "#ccfbf1",
  },
  minimal: {
    cardBg: "#334155",
    cardBgEnd: "#475569",
    textColor: "#f8fafc",
    accentColor: "#94a3b8",
    metaColor: "#cbd5e1",
  },
};

export function mergeWeatherObjStyle(weatherObj) {
  const variant = weatherObj?.variant || "glass-card";
  const base = DEFAULTS[variant] || DEFAULTS["glass-card"];
  const s =
    weatherObj?.style && typeof weatherObj.style === "object"
      ? weatherObj.style
      : {};
  return { ...base, ...s };
}

export function weatherStyleColorForInput(value, fallback) {
  if (typeof value === "string" && /^#[0-9a-fA-F]{6}$/.test(value)) {
    return value;
  }
  return fallback;
}

/**
 * @param {import('fabric').fabric.Group} group
 * @param {{ variant?: string, style?: Record<string, unknown> }} weatherObj
 */
export function applyWeatherWidgetStyle(group, weatherObj) {
  if (!group || group.type !== "group" || group.eleType !== "weather-widget") {
    return;
  }
  const variant = weatherObj?.variant || "glass-card";
  const style = mergeWeatherObjStyle(weatherObj);
  const subs = group._objects || group.getObjects?.() || [];

  const bg = subs.find((c) => c.name === "weather-card-bg");
  if (bg) {
    if (variant === "minimal") {
      bg.set({
        fill: style.cardBg,
      });
    } else {
      bg.set({
        fill: new fabric.Gradient({
          type: "linear",
          gradientUnits: "pixels",
          coords: { x1: 0, y1: 0, x2: bg.width || 280, y2: bg.height || 160 },
          colorStops: [
            { offset: 0, color: style.cardBg },
            { offset: 1, color: style.cardBgEnd },
          ],
        }),
      });
    }
  }

  subs
    .filter((c) => c.name === "weather-city-text")
    .forEach((t) => t.set({ fill: style.accentColor }));
  subs
    .filter((c) => c.name === "weather-temp-text")
    .forEach((t) => t.set({ fill: style.textColor }));
  subs
    .filter((c) => c.name === "weather-desc-text")
    .forEach((t) => t.set({ fill: style.textColor }));
  subs
    .filter((c) => c.name === "weather-meta-text")
    .forEach((t) => t.set({ fill: style.metaColor }));
  subs
    .filter((c) => c.name === "weather-minimal-text")
    .forEach((t) => t.set({ fill: style.textColor }));
  subs
    .filter((c) => c.name === "weather-icon-text")
    .forEach((t) => t.set({ fill: style.textColor, opacity: 0.92 }));
}
